var map = {
	"./desktop/image-curiosity.jpg": 23,
	"./desktop/image-deep-earth.jpg": 24,
	"./desktop/image-fisheye.jpg": 25,
	"./desktop/image-from-above.jpg": 26,
	"./desktop/image-grid.jpg": 27,
	"./desktop/image-hero.jpg": 11,
	"./desktop/image-interactive.jpg": 13,
	"./desktop/image-night-arcade.jpg": 28,
	"./desktop/image-pocket-borealis.jpg": 29,
	"./desktop/image-soccer-team.jpg": 30,
	"./icon-close.svg": 5,
	"./icon-facebook.svg": 7,
	"./icon-hamburger.svg": 6,
	"./icon-instagram.svg": 8,
	"./icon-pinterest.svg": 9,
	"./icon-twitter.svg": 10,
	"./logo.svg": 2,
	"./mobile/image-curiosity.jpg": 31,
	"./mobile/image-deep-earth.jpg": 32,
	"./mobile/image-fisheye.jpg": 33,
	"./mobile/image-from-above.jpg": 34,
	"./mobile/image-grid.jpg": 35,
	"./mobile/image-hero.jpg": 12,
	"./mobile/image-interactive.jpg": 36,
	"./mobile/image-night-arcade.jpg": 37,
	"./mobile/image-pocket-borealis.jpg": 38,
	"./mobile/image-soccer-team.jpg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;